// extracted by mini-css-extract-plugin
export default {"control":"Product_control__yfonz","richText":"Product_richText__oLh35"};